import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import NotificationOptIn, { canShowOptIn } from './NotificationOptIn'
import Skeleton from '../UI/Skeleton'
class InboxPage extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			notifications: this.props.notifications,
			conversations: null,
			activeTab: this.props.location.pathname === '/messages' ? 'messages' : 'notifications',
			logoError: false,
		}
		this.pollTimer = null
		this.lastConversationsSync = 0
	}

	componentDidMount() {
		this.props.updateLogs(this.props.history.location.pathname, 'Notifications')
		this.props.updateShell('notification', true, this.props.history.location.pathname)
		this.props.fetchNotifications()
		.then(notifications => {
			this.setState({ notifications })
		})
		.catch(err => console.log(err))
		if (this.state.activeTab === 'messages')
			this.loadConversations()
		this.pollTimer = setInterval(this.pollConversations, 5000)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.notifications !== this.props.notifications)
			this.setState({ notifications: this.props.notifications })
	}

	componentWillUnmount() {
		if (this.pollTimer)
			clearInterval(this.pollTimer)
	}

	convActivity = (conv) => {
		const edited = conv.edited_time || 0
		const created = conv.created_time || 0
		return (edited > created) ? edited : created
	}

	computeConvSync = (conversations) => {
		let last = 0
		for (let i = 0; i < conversations.length; i++)
		{
			const activity = this.convActivity(conversations[i])
			if (activity > last)
				last = activity
		}
		return last
	}

	sortConversations = (conversations) => {
		return conversations.slice().sort((a, b) => this.convActivity(b) - this.convActivity(a))
	}

	loadConversations = () => {
		this.props.fetchConversationsByUser(this.props.user._id)
		.then(conversations => {
			const sorted = this.sortConversations(conversations)
			this.lastConversationsSync = this.computeConvSync(sorted)
			this.setState({ conversations: sorted })
		})
		.catch(err => console.log(err))
	}

	pollConversations = () => {
		if (!navigator.onLine)
			return ;
		if (this.state.conversations === null || !this.props.user || !this.props.user._id)
			return ;
		this.props.pollConversationsByUser(this.props.user._id, this.lastConversationsSync)
		.then(delta => {
			if (!delta || delta.length === 0)
				return ;
			this.setState(prev => {
				const indexById = {}
				const merged = prev.conversations.slice()
				for (let i = 0; i < merged.length; i++)
					indexById[merged[i]._id] = i
				for (let i = 0; i < delta.length; i++)
				{
					if (indexById[delta[i]._id] !== undefined)
						merged[indexById[delta[i]._id]] = delta[i]
					else
						merged.push(delta[i])
				}
				return { conversations: this.sortConversations(merged) }
			}, () => {
				this.lastConversationsSync = this.computeConvSync(this.state.conversations)
			})
		})
		.catch(() => {})
	}

	switchTab = (tab) => {
		this.setState({ activeTab: tab })
		if (tab === 'messages' && this.state.conversations === null)
			this.loadConversations()
		const path = tab === 'messages' ? '/messages' : this.props.lang_assets.paths.notifications
		this.props.history.replace(path)
	}

	getDayLabel = (timestamp) => {
		const time = new Date(timestamp * 1000)
		const timeday = Math.round(new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0, 0).getTime() / 1000)
		const now = new Date()
		const today = Math.round(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime() / 1000)
		const daytime = 60 * 60 * 24
		const weektime = daytime * 7
		if (timeday + daytime > today)
			return this.props.lang_assets.time.today
		if (timeday + daytime * 2 > today)
			return this.props.lang_assets.time.yesterday
		if (timeday + weektime > today)
			return this.props.lang_assets.time.weekdays[time.getDay()]
		return time.getDate() + ' ' + this.props.lang_assets.time.months_short[time.getMonth()]
	}

	getTimeLabel = (timestamp) => {
		const time = new Date(timestamp * 1000)
		let hours = time.getHours()
		if (hours < 10)
			hours = '0' + hours
		let minutes = time.getMinutes()
		if (minutes < 10)
			minutes = '0' + minutes
		return hours + ':' + minutes
	}

	groupByDay = (notifications) => {
		const groups = []
		const indexByLabel = {}
		notifications.forEach(notif => {
			const label = this.getDayLabel(notif.created_time)
			if (indexByLabel[label] === undefined)
			{
				indexByLabel[label] = groups.length
				groups.push({ label, items: [] })
			}
			groups[indexByLabel[label]].items.push(notif)
		})
		return groups
	}

	parseDate = (timestamp) => {
		const time = new Date(timestamp * 1000)
		const timeday = Math.round(new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0, 0).getTime() / 1000)
		const now = new Date()
		const today = Math.round(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime() / 1000)
		const daytime = 60 * 60 * 24
		const weektime = daytime * 7
		let day = null
		if (timeday + daytime > today)
			day = this.props.lang_assets.time.today
		else if (timeday + daytime * 2 > today)
			day = this.props.lang_assets.time.yesterday
		else if (timeday + weektime > today)
			day = this.props.lang_assets.time.weekdays[time.getDay()]
		else
			day = time.getDate() + ' ' + this.props.lang_assets.time.months_short[time.getMonth()]
		let hours = time.getHours()
		if (hours < 10)
			hours = '0' + hours
		let minutes = time.getMinutes()
		if (minutes < 10)
			minutes = '0' + minutes
		return day + this.props.lang_assets.time.at + hours + ':' + minutes
	}

	clickNotification = (read, _id, url) => {
		if (read === false)
		{
			this.props.postClickNotification({ _id, from: 'app' })
			.then(() => this.props.history.push(url))
			.catch(err => console.log(err))
		}
		else
			this.props.history.push(url)
	}

	renderNotifications() {
		const { notifications, logoError } = this.state
		const { lang_assets, theme } = this.props
		const themeColor = '#' + theme.color1
		if (notifications === undefined || notifications === null)
		{
			return <Skeleton variant="list" className="mt-16" />
		}
		if (notifications.length === 0)
		{
			if (canShowOptIn(this.props.user))
			{
				return (
					<NotificationOptIn
						variant="screen"
						lang_assets={lang_assets}
						theme={theme}
						user={this.props.user}
						handleAcceptNotifications={this.props.handleAcceptNotifications}
					/>
				)
			}
			return (
				<div className="flex flex-col items-center justify-center py-16">
					<div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: themeColor + '18' }}>
						<svg width="30" height="30" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} style={{ color: themeColor }}>
							<path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
						</svg>
					</div>
					<span className="text-base font-medium text-slate-400">{lang_assets.notifications.empty}</span>
				</div>
			)
		}
		const groups = this.groupByDay(notifications)
		return (
			<div>
				<NotificationOptIn
					variant="card"
					lang_assets={lang_assets}
					theme={theme}
					user={this.props.user}
					handleAcceptNotifications={this.props.handleAcceptNotifications}
				/>
				{groups.map(({ label, items }) => (
					<div key={label} className="mb-2">
						<p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-1">{label}</p>
						<div className="space-y-3">
							{items.map(({ _id, title, content, created_time, read, url }) => {
								const timeLabel = this.getTimeLabel(created_time)
								return (
									<div
										key={_id}
										onClick={this.clickNotification.bind(this, read, _id, url)}
										className="rounded-2xl flex gap-3 cursor-pointer"
										style={{ padding: '14px 16px', backgroundColor: read === false ? '#f1f5f9' : '#ffffff', boxShadow: read === false ? 'none' : '0 1px 2px rgba(15,23,42,0.06), 0 0 0 1px rgba(15,23,42,0.04)' }}
									>
										<div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center bg-slate-100">
											{!logoError
												? (
													<img
														src="/logo.png"
														alt=""
														style={{ width: '100%', height: '100%', objectFit: 'contain', padding: '4px' }}
														onError={() => this.setState({ logoError: true })}
													/>
												)
												: (
													<svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} style={{ color: themeColor }}>
														<path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
													</svg>
												)
											}
										</div>
										<div className="flex-1 min-w-0">
											<div className="flex items-baseline justify-between gap-2 mb-0.5">
												<h4 className={`font-semibold text-sm leading-tight truncate ${read === false ? 'text-slate-900' : 'text-slate-700'}`} style={{ margin: 0 }}>{title}</h4>
												<span className="text-xs text-slate-400 flex-shrink-0">{timeLabel}</span>
											</div>
											<p className="text-sm text-slate-500 leading-snug" style={{ margin: 0 }}>{content}</p>
										</div>
										{read === false && (
											<div className="w-2 h-2 rounded-full flex-shrink-0 self-start mt-1.5" style={{ backgroundColor: themeColor }} />
										)}
									</div>
								)
							})}
						</div>
					</div>
				))}
			</div>
		)
	}

	renderMessages() {
		const { conversations } = this.state
		const { lang_assets, theme } = this.props
		const themeColor = '#' + theme.color1
		const typeLabel = {
			'intervention': lang_assets.messages.type_intervention,
			'message': lang_assets.messages.type_question,
		}
		if (conversations === null)
		{
			return <Skeleton variant="list" className="mt-16" />
		}
		if (conversations.length === 0)
		{
			return (
				<div className="flex flex-col items-center justify-center py-16 px-8 text-center">
					<div className="w-24 h-24 rounded-full flex items-center justify-center mb-6 ring-8 ring-white shadow-inner" style={{ backgroundColor: '#' + theme.color1 + '15' }}>
						<svg style={{ color: '#' + theme.color1 + '99' }} width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>
					</div>
					<h3 className="text-xl font-bold text-slate-800 mb-2">{lang_assets.messages.empty_title}</h3>
					<p className="text-slate-400 text-sm leading-relaxed mb-8">
						{lang_assets.messages.empty_subtitle}
					</p>
					<motion.div whileTap={{ scale: 0.95 }} className="w-full">
						<Link
							to="/nouveau-message"
							className="w-full py-4 rounded-full font-bold text-lg text-white flex items-center justify-center gap-3"
							style={{ backgroundColor: themeColor }}
						>
							<svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg>
							{lang_assets.messages.new_message}
						</Link>
					</motion.div>
				</div>
			)
		}
		return (
			<div>
				<h2 className="text-slate-400 text-xs font-black uppercase tracking-widest px-1 mb-4">{lang_assets.messages.list_header}</h2>
				<div className="divide-y divide-slate-100">
					{conversations.map((conv) => {
						const isUnread = conv.read_guest === false
						const date = conv.created_time ? this.parseDate(conv.created_time).split(this.props.lang_assets.time.at)[0].trim() : ''
						const label = typeLabel[conv.type] || conv.type
						return (
							<motion.div key={conv._id} whileTap={{ scale: 0.97 }}>
								<Link
									to={`/nouveau-message/${conv._id}`}
									className="w-full flex items-start gap-4 px-4 py-4 text-left active:bg-slate-50 transition-colors"
								>
									<div className="relative flex-shrink-0 mt-0.5">
										<div className="w-14 h-14 rounded-full flex items-center justify-center" style={{ backgroundColor: '#F0F0F0' }}>
											<svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="#9CA3AF" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>
										</div>
										{isUnread && (
											<span className="absolute bottom-0.5 right-0.5 w-3.5 h-3.5 rounded-full border-2 border-white" style={{ backgroundColor: themeColor }} />
										)}
									</div>
									<div className="flex-1 min-w-0 py-0.5">
										<div className="flex justify-between items-baseline gap-2 mb-0.5">
											<h3 className="font-bold text-base text-slate-900 truncate">{conv.title}</h3>
											<span className="text-xs text-slate-400 whitespace-nowrap">{date}</span>
										</div>
										<p className={`text-sm truncate ${isUnread ? 'text-slate-900 font-bold' : 'text-slate-500'}`}>{label}</p>
									</div>
								</Link>
							</motion.div>
						)
					})}
				</div>
			</div>
		)
	}

	render() {
		const { notifications, conversations } = this.state
		const { lang_assets, theme, features, config_messages, user } = this.props
		const showMessages = user && user._id && features === 'premium' && config_messages && config_messages.active === true
		const activeTab = showMessages ? this.state.activeTab : 'notifications'
		const themeColor = '#' + theme.color1
		const unreadNotifs = (notifications && notifications.length > 0) ? notifications.filter(n => n.read === false).length : 0
		const unreadMessages = (conversations && conversations.length > 0) ? conversations.filter(c => c.read_guest === false).length : 0
		return (
			<div className="flex flex-col bg-slate-50">
				<header className="text-white relative overflow-hidden rounded-b-[2.5rem] shadow-lg" style={{ position: 'sticky', top: 0, zIndex: 50, background: `linear-gradient(135deg, ${themeColor}, ${themeColor})` }}>
					<div className="absolute -right-4 -top-4 w-24 h-24 bg-white/10 rounded-full blur-2xl pointer-events-none" />
					<div className="absolute -left-4 -bottom-4 w-32 h-32 bg-black/5 rounded-full blur-2xl pointer-events-none" />
					<div className="relative z-10 px-5 pt-14 pb-5">
						<h1 className="text-2xl font-bold mb-5 text-center">{lang_assets.notifications.title}</h1>
						{showMessages && (
						<div className="flex p-1.5 rounded-2xl" style={{ backgroundColor: 'rgba(0,0,0,0.12)' }}>
							<button
								onClick={this.switchTab.bind(this, 'notifications')}
								className={`flex-1 py-2.5 px-4 rounded-xl font-bold text-sm transition-all flex items-center justify-center gap-1.5 ${activeTab === 'notifications' ? 'bg-white shadow-sm' : 'text-white/80'}`}
								style={activeTab === 'notifications' ? { color: themeColor, backgroundImage: 'none' } : { backgroundImage: 'none', backgroundColor: 'transparent' }}
							>
								{lang_assets.notifications.title}
								{unreadNotifs > 0 && (
									<span style={{
										backgroundColor: '#EF4444',
										color: 'white',
										fontSize: '11px',
										fontWeight: 'bold',
										borderRadius: '999px',
										minWidth: '20px',
										height: '20px',
										display: 'inline-flex',
										alignItems: 'center',
										justifyContent: 'center',
										padding: '0 5px',
										lineHeight: 1,
									}}>
										{unreadNotifs > 9 ? '9+' : unreadNotifs}
									</span>
								)}
							</button>
							<button
								onClick={this.switchTab.bind(this, 'messages')}
								className={`flex-1 py-2.5 px-4 rounded-xl font-bold text-sm transition-all flex items-center justify-center gap-1.5 ${activeTab === 'messages' ? 'bg-white shadow-sm' : 'text-white/80'}`}
								style={activeTab === 'messages' ? { color: themeColor, backgroundImage: 'none' } : { backgroundImage: 'none', backgroundColor: 'transparent' }}
							>
								{lang_assets.messages.title}
								{unreadMessages > 0 && (
									<span style={{
										backgroundColor: '#EF4444',
										color: 'white',
										fontSize: '11px',
										fontWeight: 'bold',
										borderRadius: '999px',
										minWidth: '20px',
										height: '20px',
										display: 'inline-flex',
										alignItems: 'center',
										justifyContent: 'center',
										padding: '0 5px',
										lineHeight: 1,
									}}>
										{unreadMessages > 9 ? '9+' : unreadMessages}
									</span>
								)}
							</button>
						</div>
						)}
					</div>
				</header>
				<main className="px-4 py-6 pb-28">
					<AnimatePresence exitBeforeEnter>
						{activeTab === 'messages' ? (
							<motion.div
								key="messages"
								initial={{ opacity: 0, y: 10 }}
								animate={{ opacity: 1, y: 0 }}
								exit={{ opacity: 0, y: -10 }}
								transition={{ duration: 0.18 }}
							>
								{this.renderMessages()}
							</motion.div>
						) : (
							<motion.div
								key="notifications"
								initial={{ opacity: 0, y: 10 }}
								animate={{ opacity: 1, y: 0 }}
								exit={{ opacity: 0, y: -10 }}
								transition={{ duration: 0.18 }}
							>
								{this.renderNotifications()}
							</motion.div>
						)}
					</AnimatePresence>
				</main>
				{showMessages && activeTab === 'messages' && (
				<motion.div
					whileTap={{ scale: 0.88 }}
					transition={{ type: 'spring', stiffness: 400, damping: 17 }}
					style={{
						position: 'fixed',
						bottom: 'calc(10vh + 16px)',
						right: '16px',
						zIndex: 40,
					}}
				>
					<Link
						to="/nouveau-message"
						style={{
							backgroundColor: themeColor,
							backgroundImage: 'none',
							width: '52px',
							height: '52px',
							borderRadius: '16px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
						}}
					>
						<svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
							<path d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
						</svg>
					</Link>
				</motion.div>
				)}
			</div>
		)
	}
}

export default InboxPage
